import Vue from 'vue'

const state = {
    areas: [],
    base_evaluations: [],
    banner_types: [],
    branch_regional: [],
    branch_types: [],
    branch_size_types: [],
    company_types: [],
    country_areas: [],
    evaluation_question_types: [],
    faq_categories: [],
    genders: [],
    group_training_game_types: [],
    group_training_scores: [],
    group_training_test_types: [],
    group_training_types: [],
    group_training_module_types: [],
    group_users: [],
    library_file_categories: [],
    live_class_platform_types: [],
    live_class_test_types: [],
    live_class_scores: [],
    phone_types: [],
    presential_event_types: [],
    presential_event_date_types: [],
    presential_event_date_test_types: [],
    profiles: [],
    tags: [],
    timezones: [],
    survey_question_types: [],
    survey_types: [],
    welcome_banner_types: [],
    product_categories: [],
    reports: [],
    reward_types: [],
    reward_levels:[],
    reward_categories: [],
    reward_departments: [],
    reward_sale_product_types: [],
    reward_selection_campaigns: [],
    marital_status:[],
    webcast_types: [],
    webcast_base_evaluations: [],
    webcast_scores: [],
    webcast_evaluation_question_types: [],
    webcast_lounge_templates: [],
    webcast_test_types: [],
    presential_base_evaluations: [],
    presential_evaluation_question_types: [],
    user_types: [],
    library_file_extensions: [],
    reward_campaigns: [],
    countries:[],
    reward_audit_file_justifications: [],
    reward_audit_sell_justifications: [],
    trail_complete_categories: []
}

const actions = {
    SET_LISTS(context, [registration_lists]) {
        context.commit('SAVE_LISTS', [registration_lists])
    },

    SET_LISTS_PRESENTIAL(context, [registration_lists]) {
        context.commit('SAVE_LISTS_PRESENTIAL', [registration_lists])
    },

    SET_TIMEZONES(context, [timezones]) {
        context.commit('SAVE_TIMEZONES', [timezones])
    }
}

const mutations = {
    SAVE_LISTS: (state, [registration_lists]) => {
        Vue.set(state, 'areas', registration_lists.areas)
        Vue.set(state, 'banner_types', registration_lists.banner_types)
        Vue.set(state, 'base_evaluations', registration_lists.base_evaluations)
        Vue.set(state, 'branch_regional', registration_lists.branch_regional)
        Vue.set(state, 'branch_types', registration_lists.branch_types)
        Vue.set(state, 'company_types', registration_lists.company_types)
        Vue.set(state, 'country_areas', registration_lists.country_areas)
        Vue.set(state, 'evaluation_question_types', registration_lists.evaluation_question_types)
        Vue.set(state, 'faq_categories', registration_lists.faq_categories)
        Vue.set(state, 'genders', registration_lists.genders)
        Vue.set(state, 'group_training_game_types', registration_lists.group_training_game_types)
        Vue.set(state, 'group_training_scores', registration_lists.group_training_scores)
        Vue.set(state, 'group_training_test_types', registration_lists.group_training_test_types)
        Vue.set(state, 'group_training_types', registration_lists.group_training_types)
        Vue.set(state, 'live_class_test_types', registration_lists.live_class_test_types)
        Vue.set(state, 'group_training_module_types', registration_lists.group_training_module_types)
        Vue.set(state, 'group_users', registration_lists.group_users)
        Vue.set(state, 'library_file_categories', registration_lists.library_file_categories)
        Vue.set(state, 'library_file_extensions', registration_lists.library_file_extensions)
        Vue.set(state, 'live_class_scores', registration_lists.live_class_scores)
        Vue.set(state, 'phone_types', registration_lists.phone_types)
        Vue.set(state, 'profiles', registration_lists.profiles)
        Vue.set(state, 'tags', registration_lists.tags)
        Vue.set(state, 'reports', registration_lists.reports)
        Vue.set(state, 'survey_question_types', registration_lists.survey_question_types)
        Vue.set(state, 'survey_types', registration_lists.survey_types)
        Vue.set(state, 'welcome_banner_types', registration_lists.welcome_banner_types)
        Vue.set(state, 'help_header_slug', registration_lists.help_header_slug)
        Vue.set(state, 'reward_types', registration_lists.reward_types)
        Vue.set(state, 'reward_levels', registration_lists.reward_levels)
        Vue.set(state, 'reward_categories', registration_lists.reward_categories)
        Vue.set(state, 'reward_departments', registration_lists.reward_departments)
        Vue.set(state, 'reward_sale_product_types', registration_lists.reward_sale_product_types)
        Vue.set(state, 'reward_selection_campaigns', registration_lists.reward_selection_campaigns)
        Vue.set(state, 'marital_status', registration_lists.marital_status)
        Vue.set(state, 'webcast_types', registration_lists.webcast_types)
        Vue.set(state, 'webcast_test_types', registration_lists.webcast_test_types)
        Vue.set(state, 'webcast_base_evaluations', registration_lists.webcast_base_evaluations)
        Vue.set(state, 'webcast_evaluation_question_types', registration_lists.webcast_evaluation_question_types)
        Vue.set(state, 'register_profiles', registration_lists.register_profiles)
        Vue.set(state, 'presential_base_evaluations', registration_lists.presential_base_evaluations)
        Vue.set(state, 'presential_evaluation_question_types', registration_lists.presential_evaluation_question_types)
        Vue.set(state, 'live_class_platform_types', registration_lists.live_class_platform_types)
        Vue.set(state, 'branch_size_types', registration_lists.branch_size_types)
        Vue.set(state, 'user_types', registration_lists.user_types)
        Vue.set(state, 'reward_campaigns', registration_lists.reward_campaigns)
        Vue.set(state, 'countries', registration_lists.countries)
        Vue.set(state, 'reward_audit_file_justifications', registration_lists.reward_audit_file_justifications)
        Vue.set(state, 'reward_audit_sell_justifications', registration_lists.reward_audit_sell_justifications)
        Vue.set(state, 'webcast_lounge_templates', registration_lists.webcast_lounge_templates)
        Vue.set(state, 'webcast_scores', registration_lists.webcast_scores)
        Vue.set(state, 'trail_complete_categories', registration_lists.trail_complete_categories)
    },

    SAVE_LISTS_PRESENTIAL: (state, [registration_lists]) => {
        Vue.set(state, 'appointment_types', registration_lists.appointment_types)
        Vue.set(state, 'areas', registration_lists.areas)
        Vue.set(state, 'areas_client', registration_lists.areas_client)
        Vue.set(state, 'profiles', registration_lists.profiles)
        Vue.set(state, 'product_categories', registration_lists.product_categories)
        Vue.set(state, 'products', registration_lists.products)
        Vue.set(state, 'register_profiles', registration_lists.register_profiles)
        Vue.set(state, 'country_areas', registration_lists.country_areas)
        Vue.set(state, 'presential_event_types', registration_lists.presential_event_types)
        Vue.set(state, 'presential_event_date_types', registration_lists.presential_event_date_types)
        Vue.set(state, 'presential_event_date_test_types', registration_lists.presential_event_date_test_types)
    },

    SAVE_TIMEZONES: (state, [timezones]) => {
        Vue.set(state, 'timezones', timezones)
    },
}

const getters = {
    areas: state => {
        return state.areas
    },

    areas_client: state => {
        return state.areas_client
    },

    banner_types: state => {
        return state.banner_types
    },

    base_evaluations: state => {
        return state.base_evaluations
    },

    branch_regional: state => {
        return state.branch_regional
    },

    branch_types: state => {
        return state.branch_types
    },

    company_types: state => {
        return state.company_types
    },

    country_areas: state => {
        return state.country_areas
    },

    evaluation_question_types: state => {
        return state.evaluation_question_types
    },

    faq_categories: state => {
        return state.faq_categories
    },

    genders: state => {
        return state.genders
    },

    group_training_game_types: state => {
        return state.group_training_game_types
    },

    group_training_scores: state => {
        return state.group_training_scores
    },

    group_training_test_types: state => {
        return state.group_training_test_types
    },


    group_training_types: state => {
        return state.group_training_types
    },

    group_training_module_types: state => {
        return state.group_training_module_types
    },

    group_users: state => {
        return state.group_users
    },

    live_class_test_types: state => {
        return state.live_class_test_types
    },

    library_file_categories: state => {
        return state.library_file_categories
    },

    library_file_extensions: state => {
        return state.library_file_extensions
    },

    phone_types: state => {
        return state.phone_types
    },

    presential_event_types: state => {
        return state.presential_event_types
    },

    presential_event_date_types: state => {
        return state.presential_event_date_types
    },

    presential_event_date_test_types: state => {
        return state.presential_event_date_test_types
    },

    profiles: state => {
        return state.profiles
    },

    register_profiles: state => {
        return state.register_profiles
    },

    tags: state => {
        return state.tags
    },

    reports: state => {
        return state.reports
    },

    survey_question_types: state => {
        return state.survey_question_types
    },

    survey_types: state => {
        return state.survey_types
    },

    webcast_types: state => {
        return state.webcast_types
    },

    welcome_banner_types: state => {
        return state.welcome_banner_types
    },

    help_header_slug: state => {
        return state.help_header_slug
    },

    product_categories: state => {
        return state.product_categories
    },

    products: state => {
        return state.products
    },

    appointment_types: state => {
        return state.appointment_types
    },

    timezones: state => {
        return state.timezones
    },

    reward_types: state => {
        return state.reward_types
    },

    reward_categories: state => {
        return state.reward_categories
    },

    reward_levels: state => {
        return state.reward_levels
    },

    reward_departments: state => {
        return state.reward_departments
    },

    reward_sale_product_types: state => {
        return state.reward_sale_product_types
    },

    reward_selection_campaigns: state => {
        return state.reward_selection_campaigns
    },

    marital_status: state => {
        return state.marital_status
    },

    webcast_base_evaluations: state => {
        return state.webcast_base_evaluations
    },

    webcast_evaluation_question_types: state => {
        return state.webcast_evaluation_question_types
    },

    presential_base_evaluations: state => {
        return state.presential_base_evaluations
    },

    webcast_test_types: state => {
        return state.webcast_test_types
    },

    presential_evaluation_question_types: state => {
        return state.presential_evaluation_question_types
    },

    live_class_platform_types: state => {
        return state.live_class_platform_types
    },

    live_class_scores: state => {
        return state.live_class_scores
    },

    branch_size_types: state => {
        return state.branch_size_types
    },

    user_types: state => {
        return state.user_types
    },

    reward_campaigns: state => {
        return state.reward_campaigns
    },

    countries: state => {
        return state.countries
    },

    reward_audit_file_justifications: state => {
        return state.reward_audit_file_justifications
    },

    reward_audit_sell_justifications: state => {
        return state.reward_audit_sell_justifications
    },

    webcast_lounge_templates: state => {
        return state.webcast_lounge_templates
    },

    webcast_scores: state => {
        return state.webcast_scores
    },

    trail_complete_categories: state => {
        return state.trail_complete_categories
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
